// extracted by mini-css-extract-plugin
export default {"partnerForm":"PartnersMPIntegration_partnerForm__jL7gk","checkBoxContainer":"PartnersMPIntegration_checkBoxContainer__v-OSg","note":"PartnersMPIntegration_note__ejQ8y"};